import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FailureReasonUsage, FailureReasonBaseData } from 'common';
import { FailureReasonData, FailureReasonQueryParams, FailureReasonQueryResult } from './failure-reason.model';
import { AppSettings } from '../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class FailureReasonService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, private settings: AppSettings) {
    this.baseUrl = `${this.settings.failurereasons.url}/failure-reasons`;
  }

  list(usage?: FailureReasonUsage): Observable<FailureReasonBaseData[]> {
    return this.http.get<FailureReasonBaseData[]>(`${this.baseUrl}/options-to-select`, { params: usage ? { usage } : {} });
  }

  query(params: FailureReasonQueryParams): Observable<FailureReasonQueryResult> {
    return this.http.get<FailureReasonQueryResult>(`${this.baseUrl}`, { params: this.toQueryParams(params) });
  }

  get(id: number): Observable<FailureReasonData> {
    return this.http.get<FailureReasonData>(`${this.baseUrl}/${id}`);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  update(id: number, reason: FailureReasonData): Observable<FailureReasonData> {
    return this.http.patch<FailureReasonData>(`${this.baseUrl}/${id}`, reason);
  }

  create(reason: FailureReasonData): Observable<FailureReasonData> {
    return this.http.post<FailureReasonData>(`${this.baseUrl}`, reason);
  }

  // Dates go as ISO instants, the value the former POST body carried.
  private toQueryParams(params: FailureReasonQueryParams): Record<string, string | number | boolean> {
    return Object.fromEntries(Object.entries(params)
      .filter(([, value]) => value !== null && value !== undefined && value !== '')
      .map(([key, value]) => [key, value instanceof Date ? value.toISOString() : value]));
  }
}
